export const PROFILE_ACTIONS = {
  SAVE_PROFILE: 'SAVE_PROFILE',
  CLEAR_PROFILE: 'CLEAR_PROFILE',
};
